import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';
import NewsLanding from '../components/NewsLanding';
import { commonJotformScript } from '../utils/constants';

const NewsPage: NextPage = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])


  const updatedMeta = meta?.jotforms?.length === 0
    ? { ...meta, jotforms: commonJotformScript }
    : { ...meta }

  return (
    <>
      {updatedMeta && <MetaTagsComp {...updatedMeta} />}
      <NewsLanding {...props} />
    </>
  )
}


export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/news-landing`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default NewsPage;